module.exports = __webpack_public_path__ + "static/img/bg-en.417a9355.png";